import { useEffect, useState } from "react";

function useOffline() {
  const [isOffline, setIsOffline] = useState(navigator.onLine === false);

  useEffect(() => {
    const handleOnlineStatusChange = () => setIsOffline(false);
    const handleOfflineStatusChange = () => setIsOffline(true);

    window.addEventListener("online", handleOnlineStatusChange);
    window.addEventListener("offline", handleOfflineStatusChange);

    return () => {
      window.removeEventListener("online", handleOnlineStatusChange);
      window.removeEventListener("offline", handleOfflineStatusChange);
    };
  }, []);

  return isOffline;
}

export default useOffline;
